import { Row } from './Row';

Row.defaultProps = {
    display: 'flex',
    flexDirection: 'row',
    width: 1,
    flexWrap: 'wrap',
};

export { Row };
